import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";
import Header from "./components/Header";
import { TrialBanner } from "./components/Paywall";
import LoginPage from "./pages/LoginPage";
import LandingPage from "./pages/LandingPage";
import CalendarPage from "./pages/CalendarPage";
import BillsPage from "./pages/BillsPage";
import IncomePage from "./pages/IncomePage";
import MarkPaidPage from "./pages/MarkPaidPage";
import AuthCallback from "./pages/AuthCallback";
import PricingPage from "./pages/PricingPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PdfExportPage from "./pages/PdfExportPage";

function AppShell({ children, bare = false }) {
  return (
    <div className="min-h-screen">
      <Header />
      <TrialBanner />
      {children}
    </div>
  );
}

function Protected({ children, shell = true }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return shell ? <AppShell>{children}</AppShell> : children;
}

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<Protected><LandingPage /></Protected>} />
      <Route path="/calendar" element={<Protected><CalendarPage /></Protected>} />
      <Route path="/bills" element={<Protected><BillsPage /></Protected>} />
      <Route path="/income" element={<Protected><IncomePage /></Protected>} />
      <Route path="/paid" element={<Protected><MarkPaidPage /></Protected>} />
      <Route path="/pricing" element={<Protected><PricingPage /></Protected>} />
      <Route path="/payment/success" element={<Protected shell={false}><PaymentSuccessPage /></Protected>} />
      <Route path="/pdf" element={<Protected shell={false}><PdfExportPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Router />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
